import { render, staticRenderFns } from "./payment-approval.vue?vue&type=template&id=b3004798&"
import script from "./payment-approval.vue?vue&type=script&lang=js&"
export * from "./payment-approval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports